import { createContext, useContext } from 'react';
import { ArrowLeft, LockKeyhole, Menu } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BRAND } from '../../lib/brand';

export const PassportNavigationContext = createContext(null);

export const PassportBrandBar = ({ id, backTo, backLabel, compact = false, compactTitle, onMenu }) => {
  const navigation = useContext(PassportNavigationContext);
  const openMenu = onMenu || navigation?.openNavigation;
  return (
  <div className={`passport-brand-bar ${compact ? 'is-compact' : ''}`} data-testid={`${id}-brand-bar`}>
    <Link className="passport-bar-icon" to={backTo} aria-label={backLabel} title={backLabel} data-testid={`${id}-brand-back`}><ArrowLeft size={20} /></Link>
    <div className="passport-bar-identity" data-testid={`${id}-bar-identity`}>
      <img src={BRAND.helix} alt="Sports Hub Connect helix" data-testid={`${id}-bar-helix`} />
      <span className="passport-stone-type" title={compact ? compactTitle : BRAND.name} data-testid={compact ? 'pp-header-title' : `${id}-bar-brand-name`}>{compact ? compactTitle : BRAND.name}</span>
    </div>
    {openMenu ? <button className="passport-bar-icon passport-bar-menu" type="button" data-testid={`${id}-navigation-menu`} onClick={openMenu} aria-label="Open navigation" title="Open navigation"><Menu size={20} /></button> : <LockKeyhole className="passport-bar-lock" size={16} aria-hidden="true" />}
  </div>
  );
};